import * as i0 from '@angular/core';
import { input, computed, Component } from '@angular/core';
import { BaseDialogComponent } from '@futura/futura-ui/dialog';
import { MatMenu, MatMenuContent, MatMenuTrigger } from '@angular/material/menu';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { getIconInfo } from '@futura/futura-ui/core';
const _c0 = a0 => ({
  ghost: a0
});
function InfoPanelComponent_Conditional_0_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const icon_r1 = ctx;
    i0.ɵɵnextContext(2);
    const infoMenu_r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("matMenuTriggerFor", infoMenu_r2)("fontSet", icon_r1.fontSet);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", icon_r1.icon, " ");
  }
}
function InfoPanelComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, InfoPanelComponent_Conditional_0_Conditional_0_Conditional_0_Template, 2, 3, "mat-icon", 4);
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional((tmp_3_0 = ctx_r2.icon()) ? 0 : -1, tmp_3_0);
  }
}
function InfoPanelComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 2);
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c0, ctx_r2.state() === "GHOST"));
  }
}
function InfoPanelComponent_Conditional_0_ng_template_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function InfoPanelComponent_Conditional_0_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "fut-base-dialog", 5);
    i0.ɵɵtemplate(1, InfoPanelComponent_Conditional_0_ng_template_4_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("dialogTitle", ctx_r2.infoTitle())("infoMenu", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.infoTemplate() || null);
  }
}
function InfoPanelComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, InfoPanelComponent_Conditional_0_Conditional_0_Template, 1, 1)(1, InfoPanelComponent_Conditional_0_Conditional_1_Template, 1, 3, "mat-icon", 2);
    i0.ɵɵelementStart(2, "mat-menu", 1, 0);
    i0.ɵɵtemplate(4, InfoPanelComponent_Conditional_0_ng_template_4_Template, 2, 3, "ng-template", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(!ctx_r2.state() || ctx_r2.state() === "NONE" ? 0 : 1);
  }
}
let InfoPanelComponent = /*#__PURE__*/(() => {
  class InfoPanelComponent {
    constructor() {
      this.state = input();
      this.infoTitle = input();
      this.infoTemplate = input();
      this.iconInfo = input();
      this.icon = computed(() => {
        const iconInfo = this.iconInfo();
        if (!iconInfo) {
          return null;
        }
        if (typeof iconInfo !== 'string' && !iconInfo.icon) {
          return null;
        }
        return getIconInfo(iconInfo);
      });
    }
    static {
      this.ɵfac = function InfoPanelComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InfoPanelComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: InfoPanelComponent,
        selectors: [["fut-info-panel"]],
        inputs: {
          state: [1, "state"],
          infoTitle: [1, "infoTitle"],
          infoTemplate: [1, "infoTemplate"],
          iconInfo: [1, "iconInfo"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 1,
        consts: [["infoMenu", ""], ["backdropClass", "fut-menu-info-bg", 1, "fut-menu-info-content"], [1, "fut-skeleton", "ghost-menu", 3, "ngClass"], ["matMenuContent", ""], [1, "fut-text-opacity", 3, "matMenuTriggerFor", "fontSet"], [3, "dialogTitle", "infoMenu"], [4, "ngTemplateOutlet"]],
        template: function InfoPanelComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, InfoPanelComponent_Conditional_0_Template, 5, 1, "mat-menu", 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.infoTemplate() ? 0 : -1);
          }
        },
        dependencies: [BaseDialogComponent, MatMenu, MatMenuContent, NgClass, MatMenuTrigger, MatIcon, NgTemplateOutlet],
        styles: ["[_nghost-%COMP%]{display:flex}"]
      });
    }
  }
  return InfoPanelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { InfoPanelComponent };
